import { type ReactNode } from "react";

export function InputDescription({ children }: { children: ReactNode }) {
  return <p className="text-sm text-muted-foreground dark:text-gray-300">{children}</p>;
}

export function InputHint({ children }: { children: ReactNode }) {
  return <p className="text-sm text-muted-foreground dark:text-gray-400">{children}</p>;
}
